import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontIconComponent } from './font-icon.component';

@NgModule({
  imports: [CommonModule],
  declarations: [FontIconComponent],
  exports: [FontIconComponent]
})
export class FontIconModule {}
